/* eslint-disable react/prop-types */
// ColdAirDrain.jsx
import React from 'react'

const ColdAirDrainDefault = ({ style }) => <ColdAirDrain style={style} />

export default ColdAirDrainDefault

const ColdAirDrain = ({ style }) => {
  const svgStyle = {
    fill: '#284047',
    stroke: '#284047',
    strokeMiterlimit: 10,
    ...style,
  }
  return (
    <svg
      style={svgStyle}
      viewBox='0 0 75 75'
    >
      <description>cold air drain icon</description>
      <title>cold air drain</title>
      <g
        style={{
          transform: 'translate(11px, 13px) scale(0.17)',
        }}
      >
        <path d='M288.4,186c0.6,0,1-0.4,1-1v-74.5c0-0.6-0.4-1-1-1.1l-54-3.9c-0.5,0-1.4-0.1-2-0.1h-82c-0.6,0-1.4,0-2,0.1
        l-54,3.9c-0.6,0-1,0.5-1,1.1V185c0,0.6,0.4,1,1,1H288.4z'
        />
        <path d='M240.4,283.3c-0.7,0.1-1.3,0.2-2,0.2h-94c-0.7,0-1.3-0.1-2-0.2l-47-7.7c-0.4-0.1-0.9,0.2-1,0.6
        c0,0.1,0,0.1,0,0.2v2c0,0.6,0.4,1.1,1,1.2l47,7.7c0.7,0.1,1.3,0.2,2,0.2h94c0.7,0,1.3-0.1,2-0.2l47-7.7c0.6-0.1,1-0.6,1-1.2v-2
        c0-0.5-0.3-0.8-0.8-0.9c-0.1,0-0.1,0-0.2,0L240.4,283.3z'
        />
        <path d='M182.9,231.5c-0.6,0-1,0.4-1,1v9.5c0,0.6-0.4,1-1,1h-23c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1h23
        c0.6,0,1,0.4,1,1v9.5c0,0.6,0.4,1,1,1h17c0.6,0,1-0.4,1-1v-25c0-0.6-0.4-1-1-1H182.9z'
        />
        <path d='M103.9,243h36c0.6,0,1,0.4,1,1v2c0,0.6-0.4,1-1,1h-36c-0.6,0-1-0.4-1-1v-2C102.9,243.4,103.4,243,103.9,243z' />
        <path d='M65.3,206.9c-0.3-0.5-0.8-0.9-1.4-0.9H3c-0.6,0-1.1,0.4-1.4,0.9l-1.2,2.8C0.2,210.4,0,211,0,211.7v67.8
        c0,0.6,0.4,1,1,1h2.4c0.6,0,1-0.4,1-1V276c0-0.6,0.4-1,1-1h56.2c0.6,0,1,0.4,1,1v3.5c0,0.6,0.4,1,1,1H66c0.6,0,1-0.4,1-1v-67.8
        c0-0.7-0.2-1.3-0.4-1.9L65.3,206.9z'
        />
        <path d='M92.2,244c0-0.6-0.4-1-1-1h-1.2c-0.6,0-1-0.4-1-1l0,0c0-0.6-0.4-1.1-1-1.3l-5.1-1.5c-0.5-0.1-1,0.1-1,0.5
        c-0.1,0.5-0.5,0.9-1,1l-6.1,1.7c-0.4,0.1-0.7,0.2-1,0.4c-0.3,0.1-0.7,0.2-1,0.1h-3c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1h3
        c0.3,0,0.7,0,1,0.1c0.3,0.2,0.6,0.3,1,0.4l6.2,1.7c0.5,0.1,0.9,0.5,1,1c0,0.4,0.4,0.6,1,0.5l5-1.4c0.6-0.2,1-0.7,1-1.3l0,0
        c0-0.6,0.4-1,1-1h1.2c0.6,0,1-0.4,1-1L92.2,244z'
        />
        <path d='M120.2,32.5c0-3.6-1.7-6.6-3.8-6.6s-3.8,3-3.8,6.6c0,0.3,0,0.5,0,0.8l2.5,68c0,1.2,0.6,2.2,1.2,2.2
        s1.2-1,1.2-2.2l2.5-68C120.2,33,120.2,32.7,120.2,32.5z'
        />
        <path d='M157.7,22.7c0-4-1.7-7.2-3.8-7.2s-3.8,3.2-3.8,7.2c0,0.3,0,0.6,0,0.9l2.5,74.5c0,1.3,0.6,2.4,1.2,2.4
        s1.2-1.1,1.2-2.4l2.5-74.5C157.7,23.3,157.7,23,157.7,22.7z'
        />
        <path d='M195.2,9c0-4.7-1.7-8.5-3.8-8.5s-3.8,3.8-3.8,8.5c0,0.3,0,0.7,0,1l2.5,87.6c0,1.6,0.6,2.8,1.2,2.8
        s1.2-1.3,1.2-2.8l2.5-87.6C195.2,9.7,195.2,9.4,195.2,9z'
        />
        <path d='M232.7,22.7c0-4-1.7-7.2-3.8-7.2s-3.8,3.2-3.8,7.2c0,0.3,0,0.6,0,0.9l2.5,74.5c0,1.3,0.6,2.4,1.2,2.4
        s1.2-1.1,1.2-2.4l2.5-74.5C232.7,23.3,232.7,23,232.7,22.7z'
        />
        <path d='M270.2,32.5c0-3.6-1.7-6.6-3.8-6.6s-3.8,3-3.8,6.6c0,0.3,0,0.5,0,0.8l2.5,68c0,1.2,0.6,2.2,1.2,2.2
        s1.2-1,1.2-2.2l2.5-68C270.2,33,270.2,32.7,270.2,32.5z'
        />
        <path d='M307.4,221.5c0-0.6-0.2-1.3-0.5-1.9l-17-29.3c-0.3-0.5-0.9-0.8-1.5-0.9h-194c-0.6,0-1.2,0.4-1.5,0.9l-17,29.3
        c-0.3,0.6-0.5,1.2-0.5,1.9l0,0c0,0.6,0.4,1,1,1.1l17,1.8c0.6,0.1,1,0.1,1,0.1v47c0,0.6,0.4,1.1,1,1.2l4,0.7c0.4,0.1,0.9-0.2,1-0.6
        c0-0.1,0-0.1,0-0.2v-46.9c0-0.3,0.4-0.5,1-0.4l41,4.2c0.6,0.1,1,0.5,1,1.1v49c0,0.6,0.4,1,1,1h9c0.6,0,1-0.4,1-1v-49
        c0-0.6,0.4-1,1-1h72c0.6,0,1,0.4,1,1v49c0,0.6,0.4,1,1,1h9c0.6,0,1-0.4,1-1v-49c0-0.6,0.4-1,1-1.1l41-4.2c0.5-0.1,1,0.2,1,0.6
        v46.7c0,0.5,0.3,0.8,0.8,0.9c0.1,0,0.1,0,0.2,0l4-0.7c0.6-0.1,1-0.6,1-1.2v-47c0,0,0.5-0.1,1-0.1l17-1.8
        C307,222.6,307.4,222.1,307.4,221.5L307.4,221.5z'
        />
      </g>
    </svg>
  )
}
